<template>
    <b-card no-body>
      <b-table :items="items" :fields="fields" :show-empty="true" empty-text="Links take a few minutes to update. Please check back in 10 minutes.">
        <template v-slot:cell(updated)='data'>
          {{data.item.updated | date}}
        </template>

        <template v-slot:cell(name)='data'>
          {{data.item.detail.name}}
        </template>

        <template v-slot:cell(type)='data'>
          {{data.item.detail.type}}
        </template>

        <template v-slot:cell(value)='data'>
          {{data.item.detail.citation_value}}
        </template>

        <template v-slot:cell(status)='data'>
          {{data.item.detail.status}}
        </template>

        <template v-slot:cell(notes)='data'>
          <i v-if="data.item.detail.phone_verification" class="fas fa-phone pr-2 text-muted" v-b-tooltip.hover title="Requires phone verification by client after submission"></i>
          <i v-if="data.item.detail.client_verification" class="fas fa-user pr-2 text-muted" v-b-tooltip.hover title="Requires follow up by client after submission"></i>
          <i v-if="data.item.detail.no_photos" class="fas fa-camera pr-2 text-muted" v-b-tooltip.hover title="Site does not display photos or limits the number of photos"></i>
          <i v-if="data.item.detail.notes" class="fas fa-sticky-note text-muted" v-b-tooltip.hover :title="data.item.detail.notes"></i>
        </template>
      </b-table>
    </b-card>
</template>

<script>

// { "": "Y", "no_update": "N",  "url": null, "quick_listing": "N", "data_accuracy": "N", "previous_submission_updates_allowed": "Y",  }

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'

export default {
  name: 'links',
  mixins: [ItemMixin],
  firestore: function () {
    return {
      items: db.collection('site').doc(this.$route.params.site_id).collection('location').doc(this.$route.params.id).collection(this.collection).orderBy('created')
    }
  },
  data() {
    return {
      items: [],
      collection: 'link',
      fields: [
        {key: 'updated'},
        {key: 'name'},
        {key: 'type'},
        {key: 'value'},
        {key: 'notes'},
        {key: 'status'}
      ]
    }
  },
  metaInfo() {
    return {
      title: `${this.collection}s`
    };
  },
}
</script>

<style>

</style>
